// @flow

import styled from 'styled-components';

export default styled.div`
  position: fixed;
  background: rgba(0,0,0,.7);
  left: 0;
  top: 0;
  z-index: 99999999;
  width: 100%;
  height: 100%;
  .blob {
      width: 4rem;
      height: 4rem;
      background: #fff;
      border-radius: 50%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      box-shadow: 0 0 1rem rgba(255, 255, 255, 0.25);
  }
  .blob-2 { animation: animate-to-2 1.5s infinite; }
  .blob-3 { animation: animate-to-3 1.5s infinite; }
  .blob-1 { animation: animate-to-1 1.5s infinite; }
  .blob-4 { animation: animate-to-4 1.5s infinite; }
  .blob-0 { animation: animate-to-0 1.5s infinite; }
  .blob-5 { animation: animate-to-5 1.5s infinite; }
  @keyframes animate-to-2 {
      25%, 75% { transform: translateX(-2.5rem) scale(0.75); }
      95% { transform: translateX(0rem) scale(1); }
  }
  @keyframes animate-to-3 {
      25%, 75% { transform: translateX(2.5rem) scale(0.75); }
      95% { transform: translateX(0rem) scale(1); }
  }
  @keyframes animate-to-1 {
      25% { transform: translateX(-2.5rem) scale(0.75); }
      50%, 75% { transform: translateX(-7rem) scale(0.6); }
      95% { transform: translateX(0rem) scale(1); }
  }
  @keyframes animate-to-4 {
      25% { transform: translateX(2.5rem) scale(0.75); }
      50%, 75% { transform: translateX(7rem) scale(0.6); }
      95% { transform: translateX(0rem) scale(1); }
  }
  @keyframes animate-to-0 {
      25% { transform: translateX(-2.5rem) scale(0.75); }
      50% { transform: translateX(-7rem) scale(0.6); }
      75% { transform: translateX(-11rem) scale(0.5); }
      95% { transform: translateX(0rem) scale(1); }
  }
  @keyframes animate-to-5 {
      25% { transform: translateX(2.5rem) scale(0.75); }
      50% { transform: translateX(7rem) scale(0.6); }
      75% { transform: translateX(11rem) scale(0.5); }
      95% { transform: translateX(0rem) scale(1); }
  }
`;
